import { render, staticRenderFns } from "./SlotReel.vue?vue&type=template&id=32183698&scoped=true&"
import script from "./SlotReel.vue?vue&type=script&lang=js&"
export * from "./SlotReel.vue?vue&type=script&lang=js&"
import style0 from "./SlotReel.vue?vue&type=style&index=0&id=32183698&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32183698",
  null
  
)

export default component.exports